import styled from 'styled-components';

import { CMSBlockContainer } from '@common/components/CMSComponents/Container.styled';
import JobOfferInfo from '@common/components/JobOfferInfo';
import { Section } from '@common/components/JobOfferInfo/JobOfferInfo.styled';

export const Container = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 3)};
`;

export const JobOfferDetailsInfo = styled(JobOfferInfo)`
  ${/* sc-sel */ Section}:last-child {
    padding-bottom: 0;
  }
`;

export const DescriptionContainer = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'section', 3)};

  ${/* sc-sel */ CMSBlockContainer}:last-child {
    margin-bottom: 0;
  }
`;

export const FormContainer = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'section', 3)};
`;
